import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';

const MapaSitioPage: FC = () => {
  const breadCrumbs: Array<PageLink> = [];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        Ajustes - catálogos del sistema
      </PageTitle>
      <View />
    </>
  );
};

export { MapaSitioPage };
